<template>
  <div class="content-430 settlement-details-box">
    <!-- 显示内容 start  -->
    <section>
      <SettlementDetailsTop
        :title-str="eduAreaName"
        :edu-area-code="eduAreaCode"
        :approval-mode-id="ApprovalModeId"
        @on-download="onDownload"
        @on-finish-check="onFinishCheck"
      ></SettlementDetailsTop>
      <SettlementDetailsTable
        :key="$route.path"
        :table-data="tableData"
        :loading="loading"
      ></SettlementDetailsTable>
      <template v-if="tableType != 3">
        <SettlementDetailsFooter
          :bank-data="bankData"
        ></SettlementDetailsFooter>
      </template>
      <template v-if="tableType == 1 && detailsData.portOrg == 1">
        <SettlementDetailsStep :audit="audit"></SettlementDetailsStep>
      </template>
    </section>
    <!-- 显示内容 end  -->
    <!-- 打印内容 start  -->
    <div id="print-section" class="print-section">
      <section
        v-for="(item, index) in printData"
        :id="`settlement-download-details-${index}`"
        :key="index"
        class="settlement-download-details"
      >
        <SettlementDetailsTop
          :download="true"
          :table-data="tableData"
          :title-str="eduAreaName"
          :edu-area-code="eduAreaCode"
        ></SettlementDetailsTop>
        <div :class="['print-main', 'print-main-' + index]">
          <SettlementDetailsTable
            :key="$route.path"
            :table-data="item"
            :index="index"
            :download="true"
          ></SettlementDetailsTable>
        </div>

        <template v-if="tableType != 3 && index == printData.length - 1">
          <SettlementDetailsFooter
            :bank-data="bankData"
            :download="true"
          ></SettlementDetailsFooter>
        </template>
      </section>
    </div>

    <!-- 打印内容 end  -->
  </div>
</template>

<script>

import SettlementDetailsTop from './assets/components/SettlementDetailsTop.vue';
import SettlementDetailsTable from './assets/components/SettlementDetailsTable.vue';
import SettlementDetailsFooter from './assets/components/SettlementDetailsFooter.vue';
import SettlementDetailsStep from './assets/components/SettlementDetailsStep.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import educationAdmin from '@/request/educationAdmin/index.js';
import common from '@/request/common/index';
import { mapState, mapActions } from 'vuex';
import { deepCopy } from '@/utils/utils.js';
import { handleEventTableData, handlePrintData, handlePrintData1 } from './assets/data/utils';
import { getPdf430 } from '@/utils/htmlToPdf.js';
import JsPDF from 'jspdf';
export default {
  components: {
    SettlementDetailsTop,
    SettlementDetailsTable,
    SettlementDetailsFooter,
    SettlementDetailsStep
  },
  provide() {
    return {
      detailsData: this.detailsData,
      tableType: this.tableType,
      type: this.type,
      selectionTableRows: () => []
    };
  },
  data() {
    return {
      detailsData: JSON.parse(decodeURIComponent(this.$route.query.detailsData)),
      statementId: this.$route.query.statementId,
      type: this.$route.query.type, // 1 : 教育局-教育局账单
      tableType: this.$route.meta.tableType,
      portOrg: localStorage.getItem('portOrg'),
      tableData: [],
      printData: [],
      titleStr: '',
      eduAreaName: '',
      eduAreaCode: '',
      bankData: {
        cardNo: '',
        openBankName: '',
        cardCustName: ''
      }, // 银行账户数据
      loading: false,
      audit: [],
      phoneNo: '',
      ApprovalModeId: ''
    };
  },
  computed: {
    ...mapState(['userInfo']),
    // 是否是 2022年8月份以后
    isNinthMonth() {
      const day = this.detailsData.beginTime.split('-');
      const dayNum = String(day[0]) + String(day[1]);
      return Number(dayNum) > 202208;
    }
  },
  created() {
    this.handleRequestTable();
  },
  methods: {
    ...mapActions('orderCenter', [
      'udpateAudit'
    ]),
    handleRequestTable() {
      this.getEduOrgAllyDetail();

      this.getEduAreaName(this.portOrg == 1 ? this.userInfo.orgId : this.detailsData.eduId);
      this.getFindBankCardInfo({
        orgId: this.detailsData.data.orgId,
        acctPlatType: this.detailsData.bankType
      });
      this.getAuditDetail();
    },
    // 查询机构结算账单详情-教育局端
    async getEduOrgAllyDetail(data) {
      this.tableData = [];
      this.loading = true;
      const { sheetId, bankId: acctPlatType } = this.detailsData;
      // const { orgId } = this.detailsData.data;

      const res = await orderCenterApi.getSubOrgSheetDetailsList({ sheetId });
      //  this.getFindBankCardInfo({ orgId, acctPlatType });
      this.loading = false;
      if (res.status == 200 && res.message.length) {
        const otherOrgNameMap = [];
        res.message.forEach(item => {
          if (item.otherSubLedgerParties && item.otherSubLedgerParties.length > 0) {
            item.otherSubLedgerParties.forEach((item_1, index_1) => {
              item['otherOrgName' + (item_1.orgId)] = item_1.totalDivideAmt;
              if (!otherOrgNameMap.includes('otherOrgName' + (item_1.orgId))) {
                otherOrgNameMap.push('otherOrgName' + (item_1.orgId));
              }
            });
          }
        });
        handleEventTableData(res.message, ['noonCare', 'lateCare', 'fullCare', 'attachmentPrice', 'classroomFee', 'totalFee', 'platServiceFee', 'totalDivideAmt', 'totalChannelAmt', ...otherOrgNameMap]);
        this.tableData = res.message;
        const printData = deepCopy(this.tableData);
        this.printData = handlePrintData1(printData);
      }
      // this.loading = true;
      // let res;

      // if (this.portOrg == 1) {
      //   res = await orderCenterApi.getEduOrgAllyDetail({
      //     statementId: this.statementId,
      //     eduId: this.userInfo.orgId,
      //     acctPlatType: this.detailsData.data.bankId,
      //     isTrue: this.isNinthMonth ? 1 : 0
      //   });
      //   const { schoolTallyOrderDtlDTOList, phoneNo } = res.data.message;

      //   if (res.data.status == 200 && res.data.message.schoolTallyOrderDtlDTOList && schoolTallyOrderDtlDTOList.length) {
      //     this.phoneNo = phoneNo;
      //     handleEventTableData(schoolTallyOrderDtlDTOList, ['noonCare', 'lateCare', 'fullCare', 'daycare', 'attachmentPrice', 'classroomFee', 'totalFee', 'platServiceFee', 'orgFee', 'commission', 'merchantCommission']);
      //     this.tableData = schoolTallyOrderDtlDTOList;
      //     const printData = deepCopy(this.tableData);
      //     this.printData = handlePrintData1(printData, 8);
      //   }
      //   this.loading = false;
      // } else {
      //   res = await orderCenterApi.getOrgTallyDetailByAdmin({
      //     statementId: this.statementId,
      //     eduId: this.detailsData.eduId,
      //     acctPlatType: this.detailsData.data.bankId,
      //     isTrue: 1
      //   });

      //   if (res.data.status == 200 && res.data.message && res.data.message.length) {
      //     //  this.phoneNo = phoneNo
      //     handleEventTableData(res.data.message, ['noonCare', 'lateCare', 'fullCare', 'daycare', 'attachmentPrice', 'classroomFee', 'totalFee', 'platServiceFee', 'orgFee', 'commission', 'merchantCommission']);
      //     this.tableData = res.data.message;
      //     const printData = deepCopy(this.tableData);
      //     this.printData = handlePrintData1(printData, 8);
      //   }
      //   this.loading = false;
      // }
    },

    onFinishCheck() {
      this.getAuditDetail();
    },
    // 查询审批明细
    async getAuditDetail() {
      const res = await orderCenterApi.getQueryAndApproveSplitBills({
        sheetId: this.detailsData.sheetId
      });
      if (res.status == 200) {
        this.audit = res.message;
        this.udpateAudit(res.message);
      }
    },

    // 根据机构信息查询银行卡信息
    async getFindBankCardInfo({ acctPlatType, orgId }) {
      const res = await orderCenterApi.getFindBankCardInfo({ acctPlatType, orgId });
      if (res.data.status == 200 && res.data.message) {
        this.bankData = res.data.message;
      }
    },
    // 获取教育局下的区域名称
    async getEduAreaName(eduId) {
      const res = await educationAdmin.getEduAreaName({ eduId });
      if (res.status) {
        this.titleStr = res.message.areaName;
        this.eduAreaName = res.message.areaName;
        this.eduAreaCode = res.message.areaCode;
        common.getConfigureSettlementApprovalProcess({
          areaCode: this.eduAreaCode
        }).then(res => {
          if (res.status == 200) {
            this.ApprovalModeId = res.message;
          }
        });
      }
    },
    // 下载处理
    async onDownload(data) {
      if (this.portOrg == 0) {
        const { fileName, fileId } = await this.getPdf('print-section', data.titleStr, this);
        this.submitSettlementSheetDownRec(data, fileName, fileId);
      } else {
        this.getPdf('print-section', data.titleStr, this, {
          upload: false
        });
      }

      // const PDF = new JsPDF('l', 'pt', 'a4'); const len = this.printData.length; const promises = [];
      // this.$Spin.show();
      // for (let i = 0; i < len; i++) {
      //   promises.push(await getPdf430(`settlement-download-details-${i}`, data.titleStr, this, i));
      // }
      // if (promises.length) {
      //   Promise.all(promises).then(res => {
      //     console.log(res);
      //     res.forEach((item, key) => {
      //       PDF.addImage(item.pageData, 'JPEG', 0, 0, item.imgWidth, item.imgHeight);
      //       if ((key + 1) < len) {
      //         PDF.addPage();
      //       }
      //     });
      //     PDF.save(data.titleStr + '.pdf');
      //     this.$Spin.hide();
      //   });
      // }

      // this.getPdf('settlement-download-details', data.titleStr, this)
    },
    // 下载埋点
    async submitSettlementSheetDownRec(data, fileName, fileId) {
      // 学校确认单
      const { tableType, schId: schoolId, beginTime, bankId, orgId } = data;
      if (tableType == 2) {
        await orderCenterApi.schoolSettlementSheetDownRec({
          schoolId,
          fileName,
          fileId,
          beginTime,
          bankId
          // statementId: this.detailsData.statementId
        });
      }
      if (tableType == 1) {
        await orderCenterApi.orgSettlementSheetDownRec({
          orgId,
          fileName,
          fileId,
          beginTime,
          bankId,
          statementId: this.detailsData.statementId,
          modeTypeDes: ''
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.settlement-details-box {
  position: relative;
}
.print-section {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: -9999;
  padding: 30px;
}
.settlement-download-details {
}
</style>
